<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <div id="pass1RID">
      <v-card class="ep-rechner-box">
        <v-col cols="12" class="p-0">
          <div class="v-card__title p-0">
            <h2 class="v-card--head--title">
              {{ selectedLang.FirstTrainTile1 }}
            </h2>
          </div>
        </v-col>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div class="v-card--msg">
                <h2 class="ep-rechner-h2 pb-0">
                  {{ selectedLang.FirstTrainTileVx1 }}
                </h2>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-chip-group :mandatory="mandaKIT" v-model="kiofTicket" :disabled="pass21" active-class="primary">
                <v-chip large label class="ma-2" v-for="pass in kiofTicketValues" :key="pass.text">
                  {{ pass.text }}
                </v-chip>
              </v-chip-group>
            </v-col>
            <v-col v-if="kiofTicketText != ''" cols="12">
              <div class="v-card--msg">
                <h2 class="ep-rechner-h2 pb-0">
                  {{ additionalTrainTile7 }}
                </h2>
              </div>
            </v-col>
            <v-col v-if="kiofTicketText != ''" cols="12" sm="6">
              <p>
                {{ selectedLang.FirstTrainTileVx21 }}
              </p>
            </v-col>
            <v-col v-if="kiofTicketText != ''" cols="12" sm="6">
              <v-text-field :disabled="pass21" v-model="price" :rules="[(v) => !!v || selectedLang.FirstTrainTile15a + '', (v) => parseInt(v) != 0 || selectedLang.FirstTrainTile15b + '']" label="Preis" prefix="€"></v-text-field>
            </v-col>
            <v-col v-if="kiofTicketText != ''" cols="12">
              <v-checkbox v-model="futureRide" :label="selectedLang.FirstTrainTileVx23"></v-checkbox>
            </v-col>
            <v-cols cols="12" class="pt-0 pb-2">
              <p class="text-center mb-0 mt-0" v-html="selectedLang.FirstTrainTile6a">
              </p>
            </v-cols>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row v-if="!progress">
            <v-col cols="12">
              <v-btn id="search-fl" block :disabled="!valid" class="btn-ep-next-step" @click="validate">
                {{ selectedLang.FirstTrainTile6 }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="progress">
            <v-col cols="12">
              <v-btn block class="btn-ep-back-to" @click="restart">{{
                selectedLang.FirstTrainTile10
              }}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </div>
  </v-form>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "FirstTrainTile",
  data: function () {
    return {
      bookingCode: "",
      travelerName: "",
      valid: false,
      fromStart: false,
      inBC: "",
      hasAirl: "",
      strRail: false,
      strRailwayText: "",
      loading: false,
      alert: false,
      secAlert: false,
      pgValue: 0,
      pgQuery: false,
      pgShow: true,
      pgInterval: 0,
      showStrCB: false,
      mandaKIT: false,
      kiofTicket: "",
      kiofTicketText: "",
      price: 0,
      kiofTicketValues: [],
      futureRide: false,
    };
  },
  computed: {
    ...mapState([
      "kiofCla",
      "progress",
      "selectedDiv",
      "selectedLang",
      "dataTrain",
      "pass21",
      "bCRules",
      "tNRules",
      "slang",
    ]),
  },
  watch: {
    kiofTicket() {
      if (this.kiofTicket != null && this.kiofTicket != undefined) {
        this.kiofTicketText = this.kiofTicketValues[this.kiofTicket].valN;
      } else {
        this.kiofTicketText = "";
      }
    }
  },
  mounted: function () {
    var tempLangArray = { "de": { "FirstTrainTileVx2": "Flexpreis", "FirstTrainTileVx3": "Sparpreis", "FirstTrainTileVx4": "Super-Sparpreis", "FirstTrainTileVx5": "Sonstiges" }, "en": { "FirstTrainTileVx2": "Flex fare", "FirstTrainTileVx3": "Saver fare", "FirstTrainTileVx4": "Super saver fare", "FirstTrainTileVx5": "Other" } }
    this.kiofTicketValues = [
      {
        text: tempLangArray[this.$store.state.slang].FirstTrainTileVx2,
        valN: "flexpreis",
      },
      {
        text: tempLangArray[this.$store.state.slang].FirstTrainTileVx3,
        valN: "sparpreis",
      },
      {
        text: tempLangArray[this.$store.state.slang].FirstTrainTileVx4,
        valN: "supersparpreis",
      },
      {
        text: tempLangArray[this.$store.state.slang].FirstTrainTileVx5,
        valN: "sonstiges",
      },
    ]
  },
  methods: {
    ...mapActions([
      "setSelectedDiv",
      "setVar",
      "getRailData",
      "goToStep",
      "killRun",
    ]),
    restart() {
      this.killRun({ vm: this });
    },
    formatDBText(str, values) {
      var result;
      var reg = /(\w+.?\w+.?\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
    async validate() {
      this.$store.state.kiofCla = "TRFDB";
      var go4ward = true;
      if (this.$refs.form.validate()) {
        switch (this.kiofTicketText) {
          case "flexpreis":
            go4ward = false;
            this.$store.state.rejectionMessage =
              this.selectedLang.FirstTrainTileVx6;
            break;
          case "sparpreis":
            go4ward = false;
            this.$store.state.rejectionMessage =
              this.selectedLang.FirstTrainTileVx7;
            break;
          case "supersparpreis":
            go4ward = true;
            break;
          case "sonstiges":
            go4ward = false;
            this.$store.state.rejectionMessage =
              this.selectedLang.FirstTrainTileVx8;
            break
          default:
            go4ward = false;
            break;
        }


        if (go4ward) {
          this.dataTrain.price = this.price;
          this.setVar({
            pos: "selectedCase",
            val: {
              text: this.selectedLang.FirstTrainTile16,
              val: "TRFDB",
              valN: 7,
            },
          });
          this.dataTrain.nOfRides = 2;
          this.dataTrain.nOPa = 2;
          this.setSelectedDiv("21");
          this.setVar({ pos: "futureRide", val: this.futureRide });
          this.setVar({ pos: "dataTrain", val: this.dataTrain });
          this.setVar({ pos: "kiofCla", val: "TRFDB" });
        } else {
          this.setSelectedDiv("32");
        }
      }
      this.goToStep({ vm: this, val: this.selectedDiv });
      this.setVar({ pos: "progress", val: true });
      this.$gtag.event("1. Zug eingegeben", {
        event_category: "Rechner",
        event_label: "1. Zug eingegeben",
      });
    },
  },
};
</script>
